import { Component, OnInit, ViewChild } from '@angular/core';
import { DatePipe } from '@angular/common';
import * as CryptoJS from 'crypto-js';

import { Constants } from '../../../../../app.const';

@Component({
  selector: 'app-quick-link',
  templateUrl: './quick-link.component.html',
})
export class QuickLinkComponent implements OnInit {

  quickLinkList: Array<any> = [];
  private constants = Constants;

  constructor() { }

  ngOnInit() {
    var link = this.constants.quickLink;
    this.quickLinkList = Object.keys(link).map((key) => { return link[key] });
  }

}



// WEBPACK FOOTER //
// ./src/app/modules/dashboard/components/maindashboard/quick-link/quick-link.component.ts